import React, { useState } from 'react';
import { StyledSelectableButton } from './SelectableButton.styled';
import { useAudio } from '../../providers/AudioContext';

const SelectableButton = ({ img, imgHover = null, onClick, selected=false, isIconButton=false, backgroundOverwrite=null, borderOverwrite=null, disabled=false }) => {
  const { playSFX } = useAudio();
  const [hovered, setHovered] = useState(false);
  const onMouseEnter = () => {
    playSFX('hover');
    setHovered(true);
  };
  const onMouseLeave = () => {
    setHovered(false);
  };
  const onButtonClick = () => {
    playSFX('button');
    if (onClick) {
      onClick();
    }
  };
  return (
    <StyledSelectableButton onClick={onButtonClick} $selected={selected} $icon={isIconButton} $borderOverwrite={borderOverwrite} $backgroundOverwrite={backgroundOverwrite} $disabled={disabled}>
      <div className='selectable-button-content'
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}>
        <img src={hovered && imgHover ? imgHover : img} style={{scale: disabled ? '1.0' : hovered ? '1.2' : '1.0' }} />
      </div>
      <div className='selectable-button-corner selectable-button-corner-l' />
      <div className='selectable-button-corner selectable-button-corner-r' />
    </StyledSelectableButton>
  )
};

export default SelectableButton;


